<script>
import Category from "@/views/components/category.vue";
import ShopOption from "@/views/components/shopOption.vue";
import UploadList from "@/views/components/uploadList.vue";
import { formatApiDate, getFileName } from "@/utils/utils";
import {
  DIALOG_TITLE_TYPE,
  PRODUCT_TYPE,
  UPLOAD_IMG_TYPE,
  PRODUCT_DELIVERY_TIME,
  PRODUCT_TYPE_TAG,
  YES_NO_LIST
} from "@/utils/enumUtile";
import {
  editGoods,
  getGoodsEditDetail,
  getGiftConfigs,
  deleteGoodsSpecs,
  getSelectableGoodsTagList,
  queryJstSuppliers,
  queryJstDistributionSuppliers
} from "@/api/product";
import { getPostagesList } from "@/api/store";
import { uploadImage } from "@/api/common";
import { Message } from "element-ui";
import moment from "moment";
import { quillEditor } from "vue-quill-editor";
import Sortable from "sortablejs";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

export default {
  name: "addOrEditProduct",
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    PRODUCT_TYPE_LIST() {
      return PRODUCT_TYPE;
    },
    PRODUCT_DELIVERY_TIME() {
      return PRODUCT_DELIVERY_TIME;
    },
    PRODUCT_TYPE_TAG() {
      return PRODUCT_TYPE_TAG;
    },
    YES_NO_LIST() {
      return YES_NO_LIST;
    },
    isSuperSubsidy() {
      return Number(this.form.expendRate) > 100;
    }
  },
  components: { Category, UploadList, quillEditor, ShopOption },
  data() {
    return {
      rules: {
        shopId: [{ required: true, message: "店铺不能为空", trigger: "change" }],
        type: [{ required: true, message: "商品类型不能为空", trigger: "change" }],
        // merchantName: [
        //   { required: true, message: "卖家名称不能为空", trigger: "change" },
        // ],
        // merchantPhone: [
        //   { required: true, message: "卖家手机号不能为空", trigger: "change" },
        // ],
        // merchantAddress: [
        //   { required: true, message: "卖家地址不能为空", trigger: "change" },
        // ],
        name: [{ required: true, message: "商品名称不能为空", trigger: "change" }],
        category: [{ required: true, message: "商品类目不能为空", trigger: "change" }],
        adPrice: [{ required: true, message: "营销价格不能为空", trigger: "change" }],
        sku: [{ required: true, message: "商品sku不能为空", trigger: "change" }],
        mainGraph: [
          {
            required: true,
            message: "商品主图地址不能为空",
            trigger: "change"
          }
        ],
        goodsGraph: [{ required: true, message: "商品图地址不能为空", trigger: "change" }],
        detailInfo: [
          {
            required: true,
            message: "商品详情介绍不能为空",
            trigger: "change"
          }
        ],
        deliveryTime: [{ required: true, message: "发货失效不能为空", trigger: "change" }],
        specsArr: [
          {
            required: true,
            message: "商品规格信息不能为空",
            trigger: "change"
          }
        ],
        isRecomm: [{ required: true, message: "是否推荐不能为空", trigger: "change" }],
        specsPriceArr: [
          {
            required: true,
            message: "商品规格价格库存信息不能为空",
            trigger: "change"
          }
        ],
        postagesId: [
          {
            required: true,
            message: "邮费模版不能为空",
            trigger: "change"
          }
        ],
        supplierMode: [{ required: true, message: "请选择商品来源", trigger: "change" }],
        expendRate: [
          { required: true, message: "贡献值比例不能为空", trigger: ["blur", "change"] }
        ],
        raffleNum: [{ required: true, message: "抽奖次数不能为空", trigger: ["blur", "change"] }]
      },
      form: {
        id: null,
        shopId: null,
        type: null,
        name: null,
        tag: [],
        category: [],
        adPrice: null,
        goodsBrief: "",
        sellingPoint: "",
        specMode: 0,
        mainGraph: null,
        bargainMainGraph: null,
        goodsGraph: null,
        detailInfo: null,
        postagesId: null, // 邮费模版
        jstSupplierId: null,
        jstSupplierName: "",
        supplierMode: "SELF",
        specsArr: [], //商品规格信息 [{"type":"颜色","items":[{"n":"蓝色","i":"图标地址(可为空)"},{"n":"黑色","i":"图标地址(可为空)"}]},{"type":"尺寸","items":[{"n":"37","i":"图标地址(可为空)"}]}]
        specsPriceArr: [], //商品规格价格库存信息
        buyLimit: null,
        isEnterpriseUser: 0, // 是否支持企业：0，支持普通用户，1:支持企业用户
        deliveryTime: null, // 发货失效
        porpAge: null, // 适用年龄
        limitedTime: 0, // 限时活动时间
        porpSex: null, // 适用性别
        porpStyle: null, // 风格
        porpNum: null, // 货号
        porpOntime: null, // 上市时间
        porpOrigin: null, // 产地
        expendRate: null, // 贡献值比例
        subsidySort: 0, // 超级补贴排序
        raffleNum: null, // 抽奖次数
        vcoinRate: null, // 赠送交易币的比例
        bonusRate: null, //赠送推广佣金的比例
        redpacketRate: null, // 赠送现金红包的比例
        balanceRate: null, // 赠送现金余额的比例
        exchangeNum: null, //赠送兑换券的数量
        exchangeValue: null, // 赠送兑换券的面值
        deductionNum: null, // 赠送抵扣券的数量
        deductionValue: null, //赠送抵扣券的面值
        isRecomm: null, // 是否推荐
        supplyPrice: null, // 供货价格
        buyDeduction: null, // 抵扣券抵扣金额
        buyDeductionMax: null, // 抵扣券抵扣上限
        virtualSales: null, // 虚拟销量
        keywords: "",
        merchantName: "",
        merchantPhone: "",
        merchantAddress: ""
      },
      activeSection: "base",
      btnLoading: false,
      editorOption: {
        placeholder: "请输入",
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rt1" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ font: [] }],
              [{ align: [] }],
              ["link", "image", "video"],
              ["clean"]
            ],
            handlers: {
              //此处是图片上传时候需要使用到的
              image: value => {
                if (value) {
                  // 点击图片
                  document.querySelector(".uploadFile input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
              upload: value => {
                if (value) {
                  // 点击图片
                  document.querySelector(".uploadFile input").click();
                }
              }
            }
          },
          clipboard: {
            // 剪切板事件
            matchers: [
              ["img", this.handlePasteImg] // 匹配图片剪切板
            ]
          }
        }
      },
      isSddSpecification: true, // 添加规格的按钮是否可用
      batch: {
        option: [],
        batchType: [],
        count: null,
        price: null,
        originalPrice: null,
        supplyPrice: null
      }, // 批量执行的一些数据
      goodsTagOptions: [],
      jstSupplierOptions: [],
      jstSupplierLoading: false,
      postagesOption: [], // 邮费模版
      giftConfigs: [], // 模版配置
      isCoupon: this.$route.query.isCoupon || 0, // 是否抵扣券
      detailImages: [],
      detailDraggingIndex: null,
      detailDropActive: false,
      detailSortableInstance: null,
      detailPreviewVisible: false,
      detailPreviewUrl: "",
      detailPreviewIndex: 0
    };
  },
  created() {
    this.getEnabledGoodsTagList();
    this.getPostagesList();
  },
  mounted() {
    this.getGiftConfigs();
    const id = this.$route.params.id;
    if (id && id !== 0) {
      this.form.id = id;
      this.getById();
    } else {
      this.handleSpecModeChange(0);
    }
    this.form.type = this.isCoupon == 1 ? 3 : null;
  },
  beforeDestroy() {
    if (this.detailSortableInstance) this.detailSortableInstance.destroy();
    this.detailSortableInstance = null;
  },
  methods: {
    /**
     * 返回列表
     */
    jumpList() {
      this.$confirm("当前编辑的内容未保存，是否立即返回商品列表？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 抵扣券
        const path = this.isCoupon == 1 ? "/product/deductionGoodsList" : "/product/list";
        this.$router.push({ path: path });
      });
    },
    /**
     * 查询编辑详情
     */
    getById() {
      getGoodsEditDetail({ id: this.form.id }).then(resp => {
        if (resp.bizcode === 100) {
          const data = resp.data;
          this.form = {
            id: data.id,
            shopId: data.shopId,
            type: data.type,
            name: data.name,
            tag: this.parseGoodsTags(data.tag),
            adPrice: data.adPrice,
            goodsBrief: data.goodsBrief || "",
            sellingPoint: data.sellingPoint || "",
            specMode: data.specMode === 0 ? 0 : 1,
            detailInfo: data.detailInfo,
            postagesId: data.postagesId, // 邮费模版
            jstSupplierId: null,
            jstSupplierName: "",
            supplierMode: "SELF",
            buyLimit: data.buyLimit,
            virtualSales: data.virtualSales, // 虚拟销量
            isEnterpriseUser: data.isEnterpriseUser,
            deliveryTime: data.deliveryTime, // 发货失效
            porpAge: data.porpAge, // 适用年龄
            porpSex: data.porpSex, // 适用性别
            limitedTime: data.limitedTime, // 限时活动时间
            porpStyle: data.porpStyle, // 风格
            porpNum: data.porpNum, // 货号
            porpOntime: data.porpOntime, // 上市时间
            porpOrigin: data.porpOrigin, // 产地
            expendRate: data.expendRate ? data.expendRate * 100 : 0,
            subsidySort: data.subsidySort || 0,
            raffleNum: data.raffleNum,
            vcoinRate: data.vcoinRate ? data.vcoinRate * 100 : 0,
            bonusRate: data.bonusRate ? data.bonusRate * 100 : 0,
            redpacketRate: data.redpacketRate ? data.redpacketRate * 100 : 0,
            balanceRate: data.balanceRate ? data.balanceRate * 100 : 0,
            buyDeduction: data.buyDeduction ? data.buyDeduction : 0, // 抵扣券抵扣金额
            buyDeductionMax: data.buyDeductionMax ? data.buyDeductionMax : 0, // 抵扣券抵扣上限
            exchangeNum: data.exchangeNum,
            exchangeValue: data.exchangeValue,
            deductionNum: data.deductionNum,
            deductionValue: data.deductionValue,
            isRecomm: data.isRecomm,
            supplyPrice: data.supplyPrice,
            merchantName: data.merchantName,
            merchantPhone: data.merchantPhone,
            merchantAddress: data.merchantAddress,
            keywords: data.keywords || ""
          };
          this.$nextTick(() => this.refreshDetailImages());
          // 主图地址
          if (data.mainGraph) {
            const attDataArr = [];
            attDataArr.push({
              url: data.mainGraph,
              dbUrl: data.mainGraph,
              name: getFileName(data.mainGraph)
            });
            this.form.mainGraph = attDataArr;
          }
          if (data.bargainMainGraph) {
            this.form.bargainMainGraph = [
              {
                url: data.bargainMainGraph,
                dbUrl: data.bargainMainGraph,
                name: getFileName(data.bargainMainGraph)
              }
            ];
          }
          // 商品图地址
          if (data.goodsGraph) {
            const attDataArr = [];
            const defImgArr = data.goodsGraph.split(",");
            defImgArr.map(item => {
              attDataArr.push({
                url: item,
                dbUrl: item,
                name: getFileName(item)
              });
            });
            this.form.goodsGraph = attDataArr;
          }
          // 类目
          if (data.category) {
            this.form.category = String(data.category)
              .split(",")
              .map(item => parseInt(item, 10))
              .filter(item => !Number.isNaN(item) && item > 0);
          }
          // 商品的规格
          if (data.specs) {
            console.log("商品的规格", data.specs);
            const specsArr = JSON.parse(data.specs);
            const newSpecsArr = [];
            specsArr.map(item => {
              if (Array.isArray(item.items)) {
                item.items.forEach((itemsItem, itemsIndex) => {
                  itemsItem.specsId = itemsIndex + 1;
                });
              }
              newSpecsArr.push({
                ...item,
                isEdit: false
              });
            });
            console.log("商品的规格-2", newSpecsArr);
            this.form.specsArr = newSpecsArr;
          }
          // 商品的规格的详细规格和库存信息
          console.log("商品的规格的详细规格和库存信息", data.combs);
          if (data.combs) {
            const combs = data.combs;
            const newCombArr = [];
            combs.map((item, index) => {
              newCombArr.push({
                n: item.combNames,
                p: item.price,
                s: item.stock,
                m: item.mchNo,
                supplyPrice: item.supplyPrice,
                originalPrice: item.originalPrice || data.adPrice || item.price,
                skuName: item.skuName || `${data.name} ${item.combNames || ""}`.trim(),
                skuImage: item.skuImage || data.mainGraph || "",
                specValuePath: item.specValuePath || "",
                skuEnabled: item.skuEnabled !== false,
                jstSupplierId: item.jstSupplierId || null,
                jstSupplierName: item.jstSupplierName || "",
                supplierMode:
                  item.supplierMode ||
                  (item.jstSupplierId || item.jstSupplierName ? "INTERNAL" : "SELF"),
                id: item.id,
                specsId: item.specsId || index + 1
              });
            });
            this.form.specsPriceArr = newCombArr;
            this.batch.option = newCombArr;
            const supplierRow = newCombArr.find(item => item.jstSupplierId || item.jstSupplierName);
            const sourceRow = newCombArr.find(item => item.supplierMode) || supplierRow;
            this.form.supplierMode = sourceRow ? sourceRow.supplierMode || "INTERNAL" : "SELF";
            if (supplierRow && this.form.supplierMode !== "SELF") {
              this.form.jstSupplierId = supplierRow.jstSupplierId || null;
              this.form.jstSupplierName = supplierRow.jstSupplierName || "";
              this.querySupplierOptions(this.form.supplierMode);
            }

            console.log("商品的规格的详细规格和库存信息", this.form.specsPriceArr);
          }
        }
      });
    },

    /**
     * 查询可赠送的赠品
     */
    getGiftConfigs() {
      getGiftConfigs().then(resp => {
        if (resp && resp.bizcode === 100) {
          this.giftConfigs = resp.data || [];
        }
      });
    },

    findGiftConfigs(keyName) {
      const giftConfigs = this.giftConfigs;
      const isIncludes = giftConfigs.find(item => item.key === keyName) !== undefined;
      return isIncludes;
    },

    getEnabledGoodsTagList() {
      getSelectableGoodsTagList().then(resp => {
        if (resp && resp.bizcode === 100) {
          this.goodsTagOptions = resp.data || [];
        }
      });
    },

    querySupplierOptions(mode = this.form.supplierMode, keyword = "") {
      if (mode === "SELF") {
        this.jstSupplierOptions = [];
        return;
      }
      this.jstSupplierLoading = true;
      const query = mode === "DISTRIBUTION" ? queryJstDistributionSuppliers : queryJstSuppliers;
      const params =
        mode === "DISTRIBUTION"
          ? {
              page_num: 1,
              page_size: 100
            }
          : {
              supplier_name: keyword,
              name: keyword,
              page_index: 1,
              page_size: 20,
              page: 1,
              pageSize: 20
            };
      query(params)
        .then(resp => {
          if (resp && resp.bizcode === 100) {
            const jstCode = resp.data && resp.data.code;
            if (jstCode !== undefined && Number(jstCode) !== 0) {
              this.jstSupplierOptions = [];
              this.$message.error((resp.data && resp.data.msg) || "供应商列表加载失败");
              return;
            }
            this.jstSupplierOptions = this.normalizeJstSuppliers(resp.data);
            this.ensureSupplierOption(this.form.jstSupplierId, this.form.jstSupplierName);
          }
        })
        .finally(() => {
          this.jstSupplierLoading = false;
        });
    },

    normalizeJstSuppliers(data) {
      const payload = data && data.data ? data.data : data;
      const rawList =
        (payload && payload.supplier_vos) ||
        (payload && payload.datas) ||
        (payload && payload.items) ||
        (payload && payload.list) ||
        (payload && payload.entitys) ||
        (Array.isArray(payload) ? payload : []);
      if (!Array.isArray(rawList)) {
        return [];
      }
      return rawList
        .map(item => {
          const id =
            item.supplier_co_id ||
            item.supplier_id ||
            item.supplierId ||
            item.supplierId2 ||
            item.id ||
            item.co_id ||
            item.supplier_code;
          const name =
            item.supplier_name ||
            item.supplierName ||
            item.name ||
            item.co_name ||
            item.company ||
            item.nick;
          return id || name
            ? {
                id,
                name: name || String(id)
              }
            : null;
        })
        .filter(Boolean);
    },

    ensureSupplierOption(id, name) {
      if ((!id && !name) || this.jstSupplierOptions.some(item => String(item.id) === String(id))) {
        return;
      }
      this.jstSupplierOptions.unshift({
        id,
        name: name || String(id)
      });
    },

    handleJstSupplierChange(value) {
      const supplier = this.jstSupplierOptions.find(item => String(item.id) === String(value));
      this.form.jstSupplierName = supplier ? supplier.name : "";
      this.applyDefaultSupplierToSku();
    },

    handleSupplierModeChange(mode) {
      this.form.jstSupplierId = null;
      this.form.jstSupplierName = "";
      this.jstSupplierOptions = [];
      this.applyDefaultSupplierToSku();
      if (mode !== "SELF") {
        this.querySupplierOptions(mode);
      }
    },

    remoteQuerySupplierOptions(keyword) {
      this.querySupplierOptions(this.form.supplierMode, keyword || "");
    },

    applyDefaultSupplierToSku() {
      this.form.specsPriceArr.forEach(item => {
        item.supplierMode = this.form.supplierMode || "SELF";
        item.jstSupplierId =
          this.form.supplierMode === "SELF" ? null : this.form.jstSupplierId || null;
        item.jstSupplierName =
          this.form.supplierMode === "SELF" ? "" : this.form.jstSupplierName || "";
      });
    },

    parseGoodsTags(tag) {
      if (Array.isArray(tag)) {
        return tag.map(item => Number(item)).filter(Boolean);
      }
      if (tag === null || tag === undefined || tag === "" || tag === 0 || tag === "0") {
        return [];
      }
      try {
        const parsed = JSON.parse(tag);
        return Array.isArray(parsed)
          ? parsed.map(item => Number(item)).filter(Boolean)
          : String(tag)
              .split(",")
              .map(item => Number(item))
              .filter(Boolean);
      } catch (e) {
        return String(tag)
          .split(",")
          .map(item => Number(item))
          .filter(Boolean);
      }
    },

    /**
     * 强制刷新
     * @param e
     */
    forceUpdate(e) {
      this.$forceUpdate();
    },

    /**
     * 获取邮费模版
     */
    getPostagesList() {
      const params = {
        page: 1,
        pageSize: 99
      };
      getPostagesList(params).then(resp => {
        if (resp && resp.bizcode === 100) {
          this.postagesOption = resp.data.entitys;
        }
      });
    },
    /**
     * 获取主营类目
     * @param type
     * @param resultArr
     */
    getCategoryValueFunc(type, resultArr) {
      if (type === "formCategory") {
        this.form.category = resultArr;
      }
    },
    /**
     * 获取店铺
     * @param type
     * @param resultArr
     */
    getShopValueFunc(type, resultArr) {
      if (type === "formShop") {
        this.form.shopId = resultArr;
      }
    },
    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getImgsValueFunc(type, value) {
      if (type === "mainGraph") {
        this.form.mainGraph = value;
      } else if (type === "goodsGraph") {
        this.form.goodsGraph = value;
      } else if (type === "bargainMainGraph") {
        this.form.bargainMainGraph = value;
      }
    },

    handleDetailEditorChange() {
      if (this.detailDraggingIndex !== null) return;
      this.refreshDetailImages();
    },
    refreshDetailImages() {
      const container = document.createElement("div");
      container.innerHTML = this.form.detailInfo || "";
      this.detailImages = Array.from(container.querySelectorAll("img"))
        .map((image, index) => ({
          src: image.getAttribute("src") || "",
          key: `${image.getAttribute("src") || "image"}-${index}`
        }))
        .filter(item => item.src);
      this.$nextTick(() => this.initDetailSortable());
    },
    initDetailSortable() {
      const list = this.$refs.detailImageList;
      if (!list) {
        if (this.detailSortableInstance) this.detailSortableInstance.destroy();
        this.detailSortableInstance = null;
        return;
      }
      if (this.detailSortableInstance && this.detailSortableInstance.el === list) return;
      if (this.detailSortableInstance) this.detailSortableInstance.destroy();
      this.detailSortableInstance = Sortable.create(list, {
        animation: 120,
        draggable: ".detail-image-item",
        forceFallback: true,
        fallbackOnBody: true,
        fallbackTolerance: 3,
        ghostClass: "detail-sortable-ghost",
        chosenClass: "detail-sortable-chosen",
        dragClass: "detail-sortable-drag",
        onStart: ({ oldIndex }) => {
          this.detailDraggingIndex = oldIndex;
          this.detailDropActive = false;
        },
        onEnd: ({ oldIndex, newIndex }) => {
          this.moveDetailImage(oldIndex, newIndex);
          this.handleDetailSortEnd();
        }
      });
    },
    moveDetailImage(fromIndex, targetIndex) {
      if (fromIndex === undefined || targetIndex === undefined || fromIndex === targetIndex) return;
      const container = document.createElement("div");
      container.innerHTML = this.form.detailInfo || "";
      const imageNodes = Array.from(container.querySelectorAll("img"));
      if (!imageNodes[fromIndex] || !imageNodes[targetIndex]) return;
      const sources = imageNodes.map(image => image.getAttribute("src") || "");
      const moved = sources.splice(fromIndex, 1)[0];
      sources.splice(targetIndex, 0, moved);
      imageNodes.forEach((image, index) => image.setAttribute("src", sources[index]));
      this.form.detailInfo = container.innerHTML;
      this.$nextTick(() => this.refreshDetailImages());
    },
    handleDetailImagePreview(src, index) {
      if (!src) return;
      this.detailPreviewIndex = typeof index === "number" ? index : 0;
      this.detailPreviewUrl = src;
      this.detailPreviewVisible = true;
    },
    prevDetailPreview() {
      if (this.detailPreviewIndex > 0) {
        this.detailPreviewIndex--;
        this.detailPreviewUrl = this.detailImages[this.detailPreviewIndex].src;
      }
    },
    nextDetailPreview() {
      if (this.detailPreviewIndex < this.detailImages.length - 1) {
        this.detailPreviewIndex++;
        this.detailPreviewUrl = this.detailImages[this.detailPreviewIndex].src;
      }
    },
    triggerDetailImageSelect() {
      this.$refs.detailImageInput.click();
    },
    handleDetailImageSelect(event) {
      const files = Array.from(event.target.files || []);
      event.target.value = "";
      this.uploadDetailImages(files);
    },
    handleDetailDragEnter() {
      if (this.detailDraggingIndex === null) this.detailDropActive = true;
    },
    handleDetailDragLeave(event) {
      if (!event.currentTarget.contains(event.relatedTarget)) this.detailDropActive = false;
    },
    handleDetailFileDrop(event) {
      this.detailDropActive = false;
      if (this.detailDraggingIndex !== null) return;
      const files = Array.from((event.dataTransfer && event.dataTransfer.files) || []);
      this.uploadDetailImages(files);
    },
    validateDetailImage(file) {
      const validType = ["image/jpeg", "image/png", "image/gif"].includes(file.type);
      const validSize = file.size / 1024 / 1024 < 50;
      if (!validType) this.$message.error("商品详情图片只能是 jpg、jpeg、png、gif 格式");
      if (!validSize) this.$message.error("商品详情图片单张不能超过 50MB");
      return validType && validSize;
    },
    async uploadDetailImages(files) {
      const images = files.filter(file => this.validateDetailImage(file));
      if (!images.length) return;
      if (images.length > 9) {
        this.$message.error("一次最多上传 9 张商品详情图片");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "上传商品详情图片中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.35)"
      });
      try {
        const urls = [];
        for (const file of images) {
          const resp = await uploadImage({ type: UPLOAD_IMG_TYPE.GOODS, file });
          if (!resp || resp.bizcode !== 100) {
            throw new Error((resp && resp.msg) || `图片 ${file.name} 上传失败`);
          }
          urls.push(resp.data.dbUrl);
        }
        this.appendDetailImages(urls);
        this.$message.success(`已上传 ${urls.length} 张商品详情图片`);
      } catch (error) {
        this.$message.error(error.message || "商品详情图片上传失败");
      } finally {
        loading.close();
      }
    },
    appendDetailImages(urls) {
      const editor = this.$refs.myQuillEditor;
      const quill = editor && editor.quill;
      if (quill) {
        let index = Math.max(0, quill.getLength() - 1);
        urls.forEach(url => {
          quill.insertEmbed(index, "image", url, "user");
          quill.insertText(index + 1, "\n", "user");
          index += 2;
        });
        quill.setSelection(index, 0, "silent");
      } else {
        const appended = urls.map(url => `<p><img src="${url}"></p>`).join("");
        this.form.detailInfo = `${this.form.detailInfo || ""}${appended}`;
      }
      this.$nextTick(() => this.refreshDetailImages());
    },
    handleDetailSortStart(index, event) {
      this.detailDraggingIndex = index;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", String(index));
      this.setDetailDragImage(event, index);
    },
    handleDetailSortDrop(targetIndex) {
      const fromIndex = this.detailDraggingIndex;
      if (fromIndex === null || fromIndex === targetIndex) {
        this.handleDetailSortEnd();
        return;
      }
      const container = document.createElement("div");
      container.innerHTML = this.form.detailInfo || "";
      const imageNodes = Array.from(container.querySelectorAll("img"));
      if (!imageNodes[fromIndex] || !imageNodes[targetIndex]) {
        this.handleDetailSortEnd();
        return;
      }
      const sources = imageNodes.map(image => image.getAttribute("src") || "");
      const moved = sources.splice(fromIndex, 1)[0];
      sources.splice(targetIndex, 0, moved);
      imageNodes.forEach((image, index) => image.setAttribute("src", sources[index]));
      this.form.detailInfo = container.innerHTML;
      this.handleDetailSortEnd();
      this.$nextTick(() => this.refreshDetailImages());
    },
    handleDetailSortEnd() {
      this.detailDraggingIndex = null;
      this.detailDropActive = false;
    },
    setDetailDragImage(event, index) {
      if (!event.dataTransfer || typeof event.dataTransfer.setDragImage !== "function") return;
      const ghost = document.createElement("div");
      ghost.className = "detail-sort-drag-ghost";
      ghost.textContent = `详情图 ${index + 1}`;
      document.body.appendChild(ghost);
      event.dataTransfer.setDragImage(ghost, 60, 20);
      window.requestAnimationFrame(() => {
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      });
    },

    /**
     * 添加 or 编辑 商品
     */
    async saveAddOrEditData() {
      if (!(await this.validateBargainMainGraph())) {
        this.activeSection = "base";
        return;
      }
      if (this.form.supplierMode !== "SELF" && !this.form.jstSupplierId) {
        this.activeSection = "base";
        this.$message.error("请选择供应商");
        return;
      }
      this.assemblyAttributeData();
      this.applyDefaultSupplierToSku();
      if (!this.validateSkuRows()) {
        this.activeSection = "price";
        return;
      }
      const enabledSkuRows = this.form.specsPriceArr.filter(item => item.skuEnabled !== false);
      const skuPrices = enabledSkuRows.map(item => Number(item.p));
      const supplyPrices = enabledSkuRows
        .map(item => Number(item.supplyPrice))
        .filter(item => !Number.isNaN(item));
      const originalPrices = enabledSkuRows
        .map(item => Number(item.originalPrice))
        .filter(item => !Number.isNaN(item) && item > 0);
      this.form.adPrice = originalPrices.length
        ? Math.max(...originalPrices)
        : Math.max(...skuPrices);
      this.form.supplyPrice = supplyPrices.length ? Math.min(...supplyPrices) : 0;
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;
          const specsArr =
            Array.isArray(form.specsArr) &&
            form.specsArr
              .filter(o => o.type && Array.isArray(o.items))
              .map(o => ({
                items: o.items.filter(item => item.n),
                type: o.type
              }));
          const params = {
            ...form,
            specsInfo: JSON.stringify(specsArr),
            specsPriceInfo: JSON.stringify(enabledSkuRows),
            category: form.category.length !== 0 ? form.category.join(",") : "",
            tag: (form.tag || []).join(",")
          };
          if (form.mainGraph && form.mainGraph.length !== 0) {
            const urlArr = form.mainGraph.map(obj => obj["dbUrl"]);
            params.mainGraph = urlArr.join(",");
          }
          if (form.goodsGraph && form.goodsGraph.length !== 0) {
            const urlArr = form.goodsGraph.map(obj => obj["dbUrl"]);
            params.goodsGraph = urlArr.join(",");
          }
          params.bargainMainGraph =
            form.type === 2 && form.bargainMainGraph && form.bargainMainGraph.length
              ? form.bargainMainGraph[0].dbUrl
              : "";
          if (form.porpOntime) {
            params.porpOntime = moment(form.porpOntime).format("YYYY-MM-DD");
          }
          params.expendRate = form.expendRate ? form.expendRate / 100 : 0;
          params.subsidySort = Number(form.expendRate) > 100 ? Number(form.subsidySort || 0) : 0;
          params.vcoinRate = form.vcoinRate ? form.vcoinRate / 100 : 0;
          params.bonusRate = form.bonusRate ? form.bonusRate / 100 : 0;
          params.redpacketRate = form.redpacketRate ? form.redpacketRate / 100 : 0;
          params.balanceRate = form.balanceRate ? form.balanceRate / 100 : 0;

          delete params.specsArr;
          delete params.specsPriceArr;
          delete params.jstSupplierId;
          delete params.jstSupplierName;
          delete params.supplierMode;
          if (!form.id || form.id === 0) {
            delete form.id;
          }
          this.btnLoading = true;
          editGoods(params)
            .then(res => {
              if (res && res.bizcode === 100) {
                this.$notify({
                  title: "成功",
                  message: "保存成功",
                  type: "success",
                  duration: 2000
                });
                // 抵扣券
                const path = this.isCoupon == 1 ? "/product/deductionGoodsList" : "/product/list";
                this.$router.push({
                  path: `${path}?isEdit=true`
                });
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },

    async validateBargainMainGraph() {
      if (
        this.form.type !== 2 ||
        !Array.isArray(this.form.bargainMainGraph) ||
        !this.form.bargainMainGraph.length
      ) {
        return true;
      }
      const imageItem = this.form.bargainMainGraph[0] || {};
      const imageUrl = imageItem.url || imageItem.dbUrl;
      if (!imageUrl) {
        this.$message.error("平价区主图读取失败，请重新上传");
        return false;
      }
      const ratioValid = await new Promise(resolve => {
        const image = new Image();
        image.onload = () => {
          const ratio = image.naturalWidth / image.naturalHeight;
          resolve(Math.abs(ratio - 350 / 196) <= 0.01);
        };
        image.onerror = () => resolve(false);
        image.src = imageUrl;
      });
      if (!ratioValid) {
        this.$message.error("平价区主图比例须为 350:196，请重新上传");
        return false;
      }
      return true;
    },

    validateSkuRows() {
      if (
        this.form.specMode === 1 &&
        this.form.specsArr.some(
          group => !group.type || !Array.isArray(group.items) || !group.items.some(item => item.n)
        )
      ) {
        this.$message.error("请完整填写规格属性名和属性值");
        return false;
      }
      if (!this.form.specsPriceArr.length) {
        this.$message.error("请至少保留一个商品条目");
        return false;
      }
      const enabledRows = this.form.specsPriceArr.filter(item => item.skuEnabled !== false);
      if (!enabledRows.length) {
        this.$message.error("请至少启用一个商品条目");
        return false;
      }
      const invalidIndex = enabledRows.findIndex(item => {
        return (
          !item.skuName ||
          Number(item.p) <= 0 ||
          Number(item.s) < 0 ||
          Number(item.supplyPrice) < 0 ||
          Number(item.originalPrice) <= 0
        );
      });
      if (invalidIndex !== -1) {
        this.$message.error(`第 ${invalidIndex + 1} 个商品条目信息不完整`);
        return false;
      }
      const settlementInvalidIndex = enabledRows.findIndex(
        item => Number(item.p) < Number(item.supplyPrice)
      );
      if (settlementInvalidIndex !== -1) {
        this.$message.error(`第 ${settlementInvalidIndex + 1} 个商品条目：销售价不可小于供货价`);
        return false;
      }
      const originalInvalidIndex = enabledRows.findIndex(
        item => Number(item.p) > Number(item.originalPrice)
      );
      if (originalInvalidIndex !== -1) {
        this.$message.error(`第 ${originalInvalidIndex + 1} 个商品条目：销售价不允许大于划线价`);
        return false;
      }
      return true;
    },

    handlePasteImg: function(node, delta) {
      // 调整为上传，给回路径
      let _self = this;
      let base64code =
        delta &&
        delta.ops &&
        delta.ops[0] &&
        delta.ops[0]["insert"] &&
        delta.ops[0]["insert"]["image"]; // 2.1
      if (
        base64code &&
        base64code.indexOf("http://") !== 0 &&
        base64code.indexOf("https://") !== 0
      ) {
        const loading = this.$loading({
          lock: true,
          text: "上传图片中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        // 已经上传的不处理，可自定义判断逻辑
        let file = _self.dataURLtoFile(base64code, "paste.png"); // 2.2
        const params = {
          type: UPLOAD_IMG_TYPE.BRAND,
          file: file
        };
        // 调用后端服务器的接口
        uploadImage(params)
          .then(resp => {
            if (resp.bizcode === 100) {
              // 获取富文本对象
              let quill = _self.$refs["myQuillEditor"].quill;
              const selection = quill.getSelection(true);
              let length = selection ? selection.index : Math.max(0, quill.getLength() - 1);
              quill.insertEmbed(length, "image", resp.data.dbUrl);
              quill.setSelection(length + 1);
              _self.$nextTick(() => _self.refreshDetailImages());
            } else {
              Message({
                message: resp.msg,
                type: "error",
                duration: 3 * 1000
              });
            }
          })
          .catch(e => {
            this.$message.error(e.message);
            this.$refs.upload.clearFiles();
          })
          .finally(() => {
            this.loading = false;
            loading.close();
          });
        // 1、等待请求返回做不到同步，先返回空，在请求回调中再添加（这里监听函数接收职能接收同步的数据，特殊处理）
        delta.ops = [];
        return delta;
      } else {
        return delta;
      }
    },
    // 图片的base64编码转为图片文件
    dataURLtoFile: function(dataurl, name) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], name, { type: mime });
    },

    // 添加规格 start
    handleSpecModeChange(mode) {
      if (mode === 0) {
        const current = this.form.specsPriceArr[0] || {};
        this.form.specsArr = [
          {
            type: "默认规格",
            isEdit: false,
            items: [{ n: "默认", i: "" }]
          }
        ];
        this.form.specsPriceArr = [
          {
            ...current,
            n: "默认",
            specsId: current.specsId || 1,
            skuName: current.skuName || this.form.name || "默认商品",
            skuImage: current.skuImage || this.getMainGraphUrl(),
            originalPrice: current.originalPrice || current.p || null,
            specValuePath: JSON.stringify({ 默认规格: "默认" }),
            skuEnabled: current.skuEnabled !== false,
            jstSupplierId: current.jstSupplierId || this.form.jstSupplierId || null,
            jstSupplierName: current.jstSupplierName || this.form.jstSupplierName || "",
            supplierMode: current.supplierMode || this.form.supplierMode || "SELF"
          }
        ];
      } else if (
        !this.form.specsArr.length ||
        (this.form.specsArr.length === 1 && this.form.specsArr[0].type === "默认规格")
      ) {
        this.form.specsArr = [
          {
            type: "颜色",
            isEdit: false,
            items: [{ n: "", i: "" }]
          }
        ];
        this.form.specsPriceArr = [];
      }
      this.assemblyAttributeData();
    },

    getMainGraphUrl() {
      const mainGraph = this.form.mainGraph;
      if (Array.isArray(mainGraph) && mainGraph.length) {
        return mainGraph[0].dbUrl || mainGraph[0].url || "";
      }
      return typeof mainGraph === "string" ? mainGraph : "";
    },

    /**
     * 添加规格
     */
    addSpecification() {
      const item = {
        type: "",
        isEdit: false,
        items: [{ n: "", i: "" }]
      };
      this.form.specsArr.push(item);
      this.$forceUpdate();
    },
    /**
     * 保存规格
     */
    savaSpecification(index, status, type) {
      this.form.specsArr[index].isEdit = status;
      this.isSddSpecification = true; // 把按钮启用
      if (type === "create") {
        // 添加规格item
        this.saveSpecificationItem(index);
      }
      this.$forceUpdate();
    },
    /**
     * 保存规格
     */
    deleteSpecification(index) {
      this.$confirm("确认要删除该规格吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.form.specsArr.splice(index, 1);
        this.assemblyAttributeData();
      });
    },
    /**
     * 添加规格items
     * @param index 父级索引
     */
    saveSpecificationItem(index) {
      this.form.specsArr[index].items.push({
        n: null, // 颜色
        i: null // 图标地址(可为空)
      });
      this.forceUpdate();
    },
    /**
     * 删除规格
     * @param index 父级索引
     * @param iIndex 子级索引
     */
    deleteSpecificationItem(index, iIndex) {
      if (this.form.specsArr[index].items.length <= 1) {
        this.$message({
          message: "请保留至少一个规格",
          type: "warning"
        });
        return;
      }
      this.form.specsArr[index].items.splice(iIndex, 1);
      this.assemblyAttributeData();
    },
    // 上传详情里的图片
    handleFileUpload(file, index, iIndex) {
      const then_ = this;
      const loading = this.$loading({
        lock: true,
        text: "上传图片中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const params = {
        type: UPLOAD_IMG_TYPE.GOODS,
        file: file.file
      };
      // 调用后端服务器的接口
      uploadImage(params)
        .then(resp => {
          if (resp.bizcode === 100) {
            let quill = then_.$refs.myQuillEditor.quill;
            const selection = quill.getSelection(true);
            let length = selection ? selection.index : Math.max(0, quill.getLength() - 1);
            quill.insertEmbed(length, "image", resp.data.dbUrl);
            quill.setSelection(length + 1);
            then_.$nextTick(() => then_.refreshDetailImages());
          } else {
            Message({
              message: resp.msg,
              type: "error",
              duration: 3 * 1000
            });
          }
        })
        .catch(e => {
          this.$message.error(e.message);
          this.$refs.upload.clearFiles();
        })
        .finally(() => {
          loading.close();
        });
    },
    // 上传前检查 - 限制单次选择不超过9张
    beforeUpload(file) {
      const uploadInput = document.querySelector(".uploadFile input");
      if (uploadInput && uploadInput.files && uploadInput.files.length > 9) {
        this.$message.error("一次性最多只能上传9张图片");
        uploadInput.value = "";
        return false;
      }
      return true;
    },
    // 添加规格 end
    assemblyAttrBlur(item) {
      if (!item.n) {
        this.$message.error("请输入规格名称");
      }
    },
    /**
     * 组装属性，生成规格表格数据
     */
    assemblyAttributeData() {
      const { specsArr, specsPriceArr } = this.form;
      const usableGroups = specsArr.filter(
        group => group.type && Array.isArray(group.items) && group.items.some(item => item.n)
      );
      if (!usableGroups.length) {
        this.form.specsPriceArr = [];
        return;
      }
      const dimensions = usableGroups.map(group =>
        group.items.filter(item => item.n).map(item => ({ ...item, type: group.type }))
      );
      const combinations = dimensions.reduce(
        (result, dimension) => result.flatMap(row => dimension.map(value => [...row, value])),
        [[]]
      );
      const existingMap = new Map();
      specsPriceArr.forEach(item => {
        if (item.specValuePath) {
          existingMap.set(item.specValuePath, item);
          try {
            const savedPath = JSON.parse(item.specValuePath);
            if (savedPath.legacyName) {
              existingMap.set(savedPath.legacyName, item);
            }
            const normalizedPath = {};
            const normalizedNames = [];
            usableGroups.forEach(group => {
              if (savedPath[group.type] !== undefined && savedPath[group.type] !== null) {
                normalizedPath[group.type] = savedPath[group.type];
                normalizedNames.push(savedPath[group.type]);
              }
            });
            if (normalizedNames.length === usableGroups.length) {
              existingMap.set(JSON.stringify(normalizedPath), item);
              existingMap.set(normalizedNames.join(" / "), item);
            }
          } catch (e) {
            // 旧数据的规格路径可能不是 JSON，继续使用规格名称匹配。
          }
        }
        if (item.n) {
          existingMap.set(item.n, item);
        }
      });
      let nextSpecsId =
        specsPriceArr.reduce((max, item) => Math.max(max, Number(item.specsId) || 0), 0) + 1;
      const result = combinations.map(combination => {
        const path = {};
        combination.forEach(item => {
          path[item.type] = item.n;
        });
        const specValuePath = JSON.stringify(path);
        const displayName = combination.map(item => item.n).join(" / ");
        const old = existingMap.get(specValuePath) || existingMap.get(displayName) || {};
        const valueImage = combination.find(item => item.i);
        return {
          ...old,
          n: displayName,
          specsId: old.specsId || nextSpecsId++,
          skuName: old.skuName || `${this.form.name || "商品"} ${displayName}`,
          skuImage: old.skuImage || (valueImage && valueImage.i) || this.getMainGraphUrl(),
          originalPrice: old.originalPrice || old.p || null,
          specValuePath,
          skuEnabled: old.skuEnabled !== false,
          jstSupplierId: old.jstSupplierId || this.form.jstSupplierId || null,
          jstSupplierName: old.jstSupplierName || this.form.jstSupplierName || "",
          supplierMode: old.supplierMode || this.form.supplierMode || "SELF"
        };
      });
      this.form.specsPriceArr = result;
      this.batch.option = result;
      this.forceUpdate();
    },
    // 生成数据
    getCombinations(data) {
      console.log("提取各属性的选项数组-1", data);
      // 提取各属性的选项数组
      const dimensions = data.map(d => d.items.map(item => item.n));
      // 计算笛卡尔积
      console.log("提取各属性的选项数组-2", dimensions, data);
      // const combinations = dimensions.reduce(
      //   (acc, current) =>{
      //         console.log('提取各属性的选项数组-3',acc,current);
      //   return  acc.flatMap((comb) => current.map((item) => [...comb, item]))
      //   },
      //   [[]]
      // );
      // console.log('提取各属性的选项数组-4',combinations);
      // // 转换为目标格式
      // const results = combinations.map((items) => ({
      //   n: items.join("♧"),
      //   p: null,
      //   s: null,
      //   m: null,
      //   id: items.id || null
      // }));
      // const batchName = combinations.map((items) => ({
      //   n: items.join("♧"),
      // }));

      let results = [];
      data.forEach((item, index) => {
        for (let ele of item.items) {
          results.push({
            n: ele.n,
            p: null
          });
        }
      });
      console.log("提取各属性的选项数组-4", results);

      this.batch.option = results;

      return results;
    },
    // 批量填写
    batchFill() {
      const specsPriceArr = this.form.specsPriceArr;
      specsPriceArr.forEach(item => {
        if (this.batch.price !== null && this.batch.price !== "") item.p = this.batch.price;
        if (this.batch.count !== null && this.batch.count !== "") item.s = this.batch.count;
        if (this.batch.supplyPrice !== null && this.batch.supplyPrice !== "") {
          item.supplyPrice = this.batch.supplyPrice;
        }
        if (this.batch.originalPrice !== null && this.batch.originalPrice !== "") {
          item.originalPrice = this.batch.originalPrice;
        }
      });
      this.forceUpdate();
    },

    uploadSkuImage(request, row) {
      const loading = this.$loading({
        lock: true,
        text: "上传图片中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.35)"
      });
      uploadImage({ type: UPLOAD_IMG_TYPE.GOODS, file: request.file })
        .then(resp => {
          if (resp.bizcode === 100) {
            row.skuImage = resp.data.dbUrl;
            this.forceUpdate();
          } else {
            this.$message.error(resp.msg || "图片上传失败");
          }
        })
        .finally(() => loading.close());
    },
    // 删除规格
    async onDeleteSpecs(item, index) {
      console.log("删除规格", item);
      if (!item.id) {
        this.form.specsPriceArr.splice(index, 1);
        return;
      }
      const { bizcode } = await deleteGoodsSpecs({ id: item.id });
      if (bizcode === 100) {
        this.form.specsPriceArr.splice(index, 1);
        this.forceUpdate();
      }
    }
  }
};
</script>

<template>
  <div class="app-container add_edit_product_warp">
    <div class="product-editor-shell">
      <div class="editor-heading">
        <div>
          <h2>{{ form.id ? "编辑商品" : "新增商品" }}</h2>
          <p>维护商品资料、SKU 价格库存和履约信息</p>
        </div>
        <div class="heading-actions">
          <el-button @click="jumpList">取消</el-button>
          <el-button type="primary" :loading="btnLoading" @click="saveAddOrEditData"
            >保存商品</el-button
          >
        </div>
      </div>

      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="top"
        class="product-editor-form"
      >
        <el-tabs v-model="activeSection" class="editor-tabs">
          <el-tab-pane label="基础设置" name="base">
            <section class="form-section">
              <h3>商品资料</h3>
              <div class="form-grid form-grid-3">
                <el-form-item label="商品名称" prop="name">
                  <el-input
                    v-model="form.name"
                    maxlength="50"
                    show-word-limit
                    placeholder="请输入商品名称"
                  />
                </el-form-item>
                <el-form-item label="商品类型" prop="type">
                  <el-select
                    v-model="form.type"
                    :disabled="isCoupon == 1"
                    placeholder="请选择商品类型"
                  >
                    <el-option
                      v-for="item in PRODUCT_TYPE_LIST"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="所属店铺" prop="shopId">
                  <ShopOption
                    :refValue="form.shopId"
                    type="formShop"
                    @valueFunc="getShopValueFunc"
                  />
                </el-form-item>
                <el-form-item label="商品类目" prop="category">
                  <Category
                    :value="form.category"
                    type="formCategory"
                    @valueFunc="getCategoryValueFunc"
                  />
                </el-form-item>
                <el-form-item label="商品标签" prop="tag">
                  <el-select
                    v-model="form.tag"
                    multiple
                    collapse-tags
                    clearable
                    placeholder="请选择商品标签"
                  >
                    <el-option
                      v-for="item in goodsTagOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="商品来源" prop="supplierMode">
                  <el-select
                    v-model="form.supplierMode"
                    placeholder="请选择商品来源"
                    @change="handleSupplierModeChange"
                  >
                    <el-option label="内部供应商" value="INTERNAL" />
                    <el-option label="分销供应商" value="DISTRIBUTION" />
                    <el-option label="自有商品" value="SELF" />
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="form.supplierMode !== 'SELF'"
                  :label="form.supplierMode === 'DISTRIBUTION' ? '分销供应商' : '内部供应商'"
                >
                  <el-select
                    v-model="form.jstSupplierId"
                    clearable
                    filterable
                    :remote="form.supplierMode === 'INTERNAL'"
                    reserve-keyword
                    :remote-method="remoteQuerySupplierOptions"
                    :loading="jstSupplierLoading"
                    :placeholder="
                      form.supplierMode === 'DISTRIBUTION'
                        ? '请选择合作的分销供应商'
                        : '请选择内部供应商'
                    "
                    @change="handleJstSupplierChange"
                    @clear="handleJstSupplierChange(null)"
                  >
                    <el-option
                      v-for="item in jstSupplierOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item v-else label="供应商">
                  <div class="supplier-source-note">自有商品无需关联供应商</div>
                </el-form-item>
                <el-form-item label="商品关键字">
                  <el-input v-model="form.keywords" placeholder="多个关键字用英文逗号分隔" />
                </el-form-item>
                <el-form-item label="商品买点">
                  <el-input
                    v-model="form.sellingPoint"
                    maxlength="500"
                    show-word-limit
                    placeholder="支持多个买点，请用英文逗号分隔"
                  />
                </el-form-item>
              </div>
              <el-form-item label="商品简介">
                <el-input
                  v-model="form.goodsBrief"
                  type="textarea"
                  :rows="3"
                  maxlength="500"
                  show-word-limit
                  placeholder="简要说明商品卖点"
                />
              </el-form-item>
              <div class="form-grid form-grid-2 compact-grid">
                <el-form-item label="是否推荐" prop="isRecomm">
                  <el-radio-group v-model="form.isRecomm">
                    <el-radio :label="true">推荐</el-radio>
                    <el-radio :label="false">不推荐</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="限购数量">
                  <el-input-number v-model="form.buyLimit" :min="0" :precision="0" />
                  <span class="field-hint">0 表示不限购</span>
                </el-form-item>

                <el-form-item label="虚拟销量" prop="virtualSales" style="width: 150px">
                  <template slot-scope="scope">
                    <el-input
                      v-model="form.virtualSales"
                      placeholder="请输入"
                      size="small"
                      type="number"
                      @input="forceUpdate($event)"
                    >
                      <div slot="suffix" class="">件</div>
                    </el-input>
                  </template>
                </el-form-item>
              </div>
            </section>

            <section class="form-section media-section">
              <h3>商品图片</h3>
              <div class="form-grid form-grid-2">
                <div class="media-upload-column">
                  <el-form-item label="商品封面图" prop="mainGraph">
                    <UploadList
                      :typeProps="UPLOAD_IMG_TYPE.BRAND"
                      paramsType="mainGraph"
                      :model="form.mainGraph"
                      :maxCount="1"
                      @valueFunc="getImgsValueFunc"
                    />
                  </el-form-item>
                  <el-form-item v-if="form.type === 2" label="平价区主图">
                    <UploadList
                      :typeProps="UPLOAD_IMG_TYPE.BRAND"
                      paramsType="bargainMainGraph"
                      :model="form.bargainMainGraph"
                      :maxCount="1"
                      :aspectRatio="350 / 196"
                      aspectRatioTip="图片比例须为 350:196"
                      @valueFunc="getImgsValueFunc"
                    />
                    <span class="field-hint">非必填，图片宽高比例须为 350:196</span>
                  </el-form-item>
                </div>
                <el-form-item label="商品轮播图" prop="goodsGraph">
                  <UploadList
                    :typeProps="UPLOAD_IMG_TYPE.BRAND"
                    paramsType="goodsGraph"
                    :model="form.goodsGraph"
                    :maxCount="6"
                    :multiple="true"
                    :dragUpload="true"
                    :sortable="true"
                    @valueFunc="getImgsValueFunc"
                  />
                </el-form-item>
              </div>
            </section>
          </el-tab-pane>

          <el-tab-pane label="价格库存" name="price">
            <section class="form-section">
              <div class="section-heading-row">
                <div>
                  <h3>商品规格</h3>
                  <p>多规格会根据属性值自动生成全部商品条目</p>
                </div>
                <el-radio-group v-model="form.specMode" @change="handleSpecModeChange">
                  <el-radio-button :label="0">单规格</el-radio-button>
                  <el-radio-button :label="1">多规格</el-radio-button>
                </el-radio-group>
              </div>

              <div v-if="form.specMode === 1" class="spec-builder">
                <div
                  v-for="(group, groupIndex) in form.specsArr"
                  :key="groupIndex"
                  class="spec-group-row"
                >
                  <div class="spec-group-name">
                    <span>属性名</span>
                    <el-input
                      v-model="group.type"
                      maxlength="20"
                      placeholder="例如：颜色"
                      @input="assemblyAttributeData"
                    />
                  </div>
                  <div class="spec-values">
                    <span>属性值</span>
                    <div class="spec-value-list">
                      <div
                        v-for="(value, valueIndex) in group.items"
                        :key="valueIndex"
                        class="spec-value-input"
                      >
                        <el-input
                          v-model="value.n"
                          maxlength="20"
                          placeholder="例如：白色"
                          @input="assemblyAttributeData"
                        />
                        <el-button
                          type="text"
                          icon="el-icon-close"
                          title="删除属性值"
                          @click="deleteSpecificationItem(groupIndex, valueIndex)"
                        />
                      </div>
                      <el-button icon="el-icon-plus" @click="saveSpecificationItem(groupIndex)"
                        >添加属性值</el-button
                      >
                    </div>
                  </div>
                  <el-button
                    class="remove-group-button"
                    type="text"
                    icon="el-icon-delete"
                    title="删除属性"
                    @click="deleteSpecification(groupIndex)"
                  />
                </div>
                <el-button type="primary" plain icon="el-icon-plus" @click="addSpecification"
                  >添加属性</el-button
                >
              </div>
            </section>

            <section class="form-section sku-section">
              <div class="section-heading-row">
                <div>
                  <h3>商品条目</h3>
                  <p>共 {{ form.specsPriceArr.length }} 个 SKU</p>
                </div>
              </div>
              <div class="batch-toolbar">
                <el-input v-model="batch.price" placeholder="销售价" />
                <el-input v-model="batch.originalPrice" placeholder="划线价" />
                <el-input v-model="batch.supplyPrice" placeholder="供货价" />
                <el-input v-model="batch.count" placeholder="库存" />
                <el-button type="primary" plain @click="batchFill">批量填充</el-button>
              </div>

              <el-table :data="form.specsPriceArr" border class="sku-table">
                <el-table-column label="图片" width="82" fixed="left">
                  <template slot-scope="scope">
                    <el-upload
                      action="#"
                      :show-file-list="false"
                      accept="image/*"
                      :http-request="request => uploadSkuImage(request, scope.row)"
                    >
                      <div class="sku-image-upload">
                        <img v-if="scope.row.skuImage" :src="scope.row.skuImage" alt="SKU图片" />
                        <i v-else class="el-icon-plus" />
                      </div>
                    </el-upload>
                  </template>
                </el-table-column>
                <el-table-column prop="n" label="规格" min-width="150" fixed="left" />
                <el-table-column label="条目名称" min-width="240">
                  <template slot-scope="scope"><el-input v-model="scope.row.skuName"/></template>
                </el-table-column>
                <el-table-column label="销售价" width="150">
                  <template slot-scope="scope"
                    ><el-input v-model="scope.row.p"
                      ><span slot="suffix">元</span></el-input
                    ></template
                  >
                </el-table-column>
                <el-table-column label="划线价" width="150">
                  <template slot-scope="scope"
                    ><el-input v-model="scope.row.originalPrice"
                      ><span slot="suffix">元</span></el-input
                    ></template
                  >
                </el-table-column>
                <el-table-column label="供货价" width="150">
                  <template slot-scope="scope"
                    ><el-input v-model="scope.row.supplyPrice"
                      ><span slot="suffix">元</span></el-input
                    ></template
                  >
                </el-table-column>
                <el-table-column label="库存" width="140">
                  <template slot-scope="scope"
                    ><el-input v-model="scope.row.s"
                      ><span slot="suffix">件</span></el-input
                    ></template
                  >
                </el-table-column>
                <el-table-column label="商品条码" min-width="180">
                  <template slot-scope="scope"
                    ><el-input v-model="scope.row.m" placeholder="选填"
                  /></template>
                </el-table-column>
                <el-table-column label="启用" width="84" align="center" fixed="right">
                  <template slot-scope="scope"
                    ><el-switch v-model="scope.row.skuEnabled"
                  /></template>
                </el-table-column>
              </el-table>
            </section>
          </el-tab-pane>

          <el-tab-pane label="物流设置" name="logistics">
            <section class="form-section">
              <h3>履约信息</h3>
              <div class="form-grid form-grid-2">
                <el-form-item label="发货时效" prop="deliveryTime">
                  <el-select v-model="form.deliveryTime" placeholder="请选择发货时效">
                    <el-option
                      v-for="item in PRODUCT_DELIVERY_TIME"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="运费模板" prop="postagesId">
                  <el-select v-model="form.postagesId" clearable placeholder="请选择运费模板">
                    <el-option
                      v-for="item in postagesOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="卖家名称"
                  ><el-input v-model="form.merchantName"
                /></el-form-item>
                <el-form-item label="卖家联系方式"
                  ><el-input v-model="form.merchantPhone"
                /></el-form-item>
              </div>
              <el-form-item label="卖家地址"
                ><el-input v-model="form.merchantAddress"
              /></el-form-item>
            </section>
          </el-tab-pane>

          <el-tab-pane label="商品详情" name="detail">
            <section
              class="form-section detail-section"
              @dragenter.prevent="handleDetailDragEnter"
              @dragover.prevent
              @dragleave="handleDetailDragLeave"
              @drop.prevent="handleDetailFileDrop"
            >
              <h3>商品详情介绍</h3>
              <el-form-item prop="detailInfo">
                <quill-editor
                  ref="myQuillEditor"
                  v-model="form.detailInfo"
                  class="content_warp"
                  :options="editorOption"
                  @change="handleDetailEditorChange"
                />
              </el-form-item>
              <div class="detail-image-manager" :class="{ 'is-dragover': detailDropActive }">
                <div class="detail-image-manager__heading">
                  <div>
                    <strong>详情图片</strong>
                    <span>拖入图片可上传，拖动缩略图可调整图片顺序</span>
                  </div>
                  <el-button
                    type="primary"
                    plain
                    size="small"
                    icon="el-icon-upload2"
                    @click="triggerDetailImageSelect"
                  >
                    选择图片
                  </el-button>
                  <input
                    ref="detailImageInput"
                    class="detail-image-input"
                    type="file"
                    accept="image/jpeg,image/png,image/gif"
                    multiple
                    @change="handleDetailImageSelect"
                  />
                </div>
                <div v-if="detailImages.length" ref="detailImageList" class="detail-image-list">
                  <div
                    v-for="(image, index) in detailImages"
                    :key="image.key"
                    class="detail-image-item"
                    :class="{ 'is-dragging': detailDraggingIndex === index }"
                    @click="handleDetailImagePreview(image.src, index)"
                  >
                    <img
                      :src="image.src"
                      :alt="`商品详情图 ${index + 1}`"
                      loading="lazy"
                      draggable="false"
                    />
                    <span class="detail-image-index">{{ index + 1 }}</span>
                    <div class="detail-image-actions">
                      <i
                        class="el-icon-zoom-in"
                        title="点击放大查看"
                        @click.stop="handleDetailImagePreview(image.src, index)"
                      ></i>
                      <i class="el-icon-rank" title="拖拽调整顺序"></i>
                    </div>
                  </div>
                </div>
                <div v-else class="detail-image-empty">
                  将商品详情图拖到这里，或点击“选择图片”批量上传
                </div>
              </div>
            </section>
          </el-tab-pane>

          <el-tab-pane label="其他设置" name="other">
            <section class="form-section">
              <h3>奖励与兑换</h3>
              <div class="form-grid form-grid-3">
                <el-form-item label="赠送贡献值比例" prop="expendRate"
                  ><el-input v-model="form.expendRate"
                    ><span slot="suffix">%</span></el-input
                  ></el-form-item
                >
                <el-form-item v-if="isSuperSubsidy" label="超级补贴排序">
                  <el-input-number v-model="form.subsidySort" :min="0" :precision="0" :step="1" />
                  <span class="field-hint subsidy-sort-hint">数值越大，展示越靠前</span>
                </el-form-item>
                <el-form-item label="赠送抽奖次数" prop="raffleNum"
                  ><el-input-number v-model="form.raffleNum" :min="0" :precision="0"
                /></el-form-item>
                <el-form-item label="赠送交易币比例"
                  ><el-input v-model="form.vcoinRate"
                    ><span slot="suffix">%</span></el-input
                  ></el-form-item
                >
                <el-form-item label="赠送现金红包比例"
                  ><el-input v-model="form.redpacketRate"
                    ><span slot="suffix">%</span></el-input
                  ></el-form-item
                >
                <el-form-item label="赠送现金余额比例"
                  ><el-input v-model="form.balanceRate"
                    ><span slot="suffix">%</span></el-input
                  ></el-form-item
                >
                <el-form-item label="可兑换金额"
                  ><el-input v-model="form.buyDeduction"
                    ><span slot="suffix">元</span></el-input
                  ></el-form-item
                >
                <el-form-item label="单用户可兑换上限"
                  ><el-input-number v-model="form.buyDeductionMax" :min="0" :precision="0"
                /></el-form-item>
                <el-form-item label="支持企业用户">
                  <el-switch
                    v-model="form.isEnterpriseUser"
                    :active-value="1"
                    :inactive-value="0"
                  />
                </el-form-item>
              </div>
            </section>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </div>

    <el-form
      v-if="false"
      ref="form"
      :rules="rules"
      :model="form"
      label-position="left"
      label-width="150px"
      style="width: calc(100% - 100px); padding:20px 50px;"
    >
      <!--      商品详细数据-->
      <el-card class="box-card card_but" shadow="hover">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <div class="text item">
          <el-row :gutter="40">
            <el-col :span="8">
              <el-form-item label="商品名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品类型" prop="type">
                <el-select
                  v-model="form.type"
                  placeholder="类型"
                  style="width: 100%"
                  class="filter-item"
                  clearable
                  :disabled="isCoupon == 1"
                >
                  <el-option
                    v-for="item in PRODUCT_TYPE_LIST"
                    :key="item.key"
                    :label="item.value"
                    :value="item.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品标签" prop="tag">
                <el-select
                  v-model="form.tag"
                  multiple
                  collapse-tags
                  placeholder="请选择商品标签"
                  style="width: 100%"
                  class="filter-item"
                  clearable
                >
                  <el-option
                    v-for="item in goodsTagOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="8">
              <el-form-item label="店铺" prop="shopId">
                <ShopOption
                  :refValue="form.shopId"
                  class="filter-item"
                  type="formShop"
                  :styleRef="{ width: '100%' }"
                  @valueFunc="getShopValueFunc"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所属类目" prop="category">
                <Category
                  :value="form.category"
                  @valueFunc="getCategoryValueFunc"
                  type="formCategory"
                  :styleRef="{ width: '100%' }"
                  :showLevels="true"
                  :isMultiple="false"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="限购数量" prop="buyLimit">
                <el-input v-model="form.buyLimit" placeholder="0表示不限" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="10">
              <el-form-item label="是否支持企业用户" prop="isEnterpriseUser">
                <el-radio-group v-model="form.isEnterpriseUser">
                  <el-radio :label="item.key" v-for="item in YES_NO_LIST" :key="item.key">{{
                    item.value
                  }}</el-radio>
                </el-radio-group>
                <!-- <el-input v-model="form.isEnterpriseUser" placeholder="0表示不限" /> -->
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="40">
            <el-col :span="24">
              <el-form-item label="关键字" prop="keywords">
                <el-input
                  type="textarea"
                  v-model="form.keywords"
                  placeholder="支持多个，用英文逗豆分隔"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item label="卖家名称" prop="merchantName">
                <el-input v-model="form.merchantName" placeholder="请输入卖家名称" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="卖家手机号" prop="merchantPhone">
                <el-input v-model="form.merchantPhone" placeholder="请输入卖家手机号" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="24">
              <el-form-item label="卖家地址" prop="merchantAddress">
                <el-input v-model="form.merchantAddress" placeholder="请输入卖家地址" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-card>
      <!--      优选设置-->
      <el-card class="box-card card_but" shadow="hover" v-if="form.type !== 0">
        <div slot="header" class="clearfix">
          <span>优选设置</span>
        </div>
        <div class="text item">
          <el-row :gutter="40">
            <el-col :span="8" v-if="findGiftConfigs('expend')">
              <el-form-item label="赠送贡献值比例" prop="porpAge">
                <el-input v-model="form.expendRate" placeholder="请输入">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="赠送抽奖次数" prop="porpAge">
                <el-input v-model="form.raffleNum" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('vcoin')">
              <el-form-item label="赠送交易币的比例" prop="vcoinRate">
                <el-input v-model="form.vcoinRate" placeholder="请输入">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('bonus')">
              <el-form-item label="赠送推广佣金的比例" prop="bonusRate">
                <el-input v-model="form.bonusRate" placeholder="请输入">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('balance')">
              <el-form-item label="赠送现金红包的比例" prop="redpacketRate">
                <el-input v-model="form.redpacketRate" placeholder="请输入">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('balance')">
              <el-form-item label="赠送现金余额的比例" prop="balanceRate">
                <el-input v-model="form.balanceRate" placeholder="请输入">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="赠送抵扣券抵扣金额" prop="buyDeduction">
                <el-input v-model="form.buyDeduction" placeholder="请输入" type="number">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8" v-if="findGiftConfigs('exchange')">
              <el-form-item label="赠送兑换券的数量" prop="exchangeNum">
                <el-input v-model="form.exchangeNum" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('exchange')">
              <el-form-item label="赠送兑换券的面值" prop="exchangeValue">
                <el-input v-model="form.exchangeValue" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('deduction')">
              <el-form-item label="赠送抵扣券的数量" prop="deductionNum">
                <el-input v-model="form.deductionNum" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="findGiftConfigs('deduction')">
              <el-form-item label="赠送抵扣券的面值" prop="deductionValue">
                <el-input v-model="form.deductionValue" placeholder="请输入" />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="每个用户可兑换上限" prop="buyDeductionMax">
                <el-input v-model="form.buyDeductionMax" placeholder="请输入" type="number">
                  <template slot="append">件</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-card>

      <!--      商品规格设置-->
      <el-card class="box-card card_but" shadow="hover">
        <div slot="header" class="clearfix">
          <span>销售信息</span>
        </div>
        <div class="text item">
          <el-form-item label="发货时效" prop="deliveryTime">
            <el-radio-group v-model="form.deliveryTime">
              <el-radio :label="item.key" v-for="item in PRODUCT_DELIVERY_TIME" :key="item.key">{{
                item.value
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="商品属性" prop="specsInfo">
            <div>
              <!--                该商品下可添加的SKU上限为136个，规范配置销售属性有助于商品转化。-->
            </div>
            <div class="specification_warp">
              <!-- 循环单个规格-->
              <div
                v-show="form.specsArr && form.specsArr.length !== 0"
                v-for="(item, index) in form.specsArr"
                :key="index"
                class="specification_item"
              >
                <!-- 规格标题-->
                <div v-if="item.isEdit" class="specification_item_isEdit">
                  <el-input
                    size="medium"
                    v-model="item.type"
                    style="width: 200px"
                    placeholder="请输入规格类型标题"
                    @input="forceUpdate($event)"
                  />
                  <el-button
                    type="primary"
                    size="mini"
                    class="but_left"
                    @click="savaSpecification(index, false, 'create')"
                    >保存</el-button
                  >
                </div>
                <div v-else>
                  <span style="margin-right: 60px">{{ item.type }}</span>
                  <el-button
                    type="success"
                    size="mini"
                    class="but_left"
                    @click="savaSpecification(index, true, 'update')"
                    >编辑</el-button
                  >
                  <el-button size="mini" class="but_left" @click="deleteSpecification(index)"
                    >删除</el-button
                  >
                </div>
                <!-- 规格具体项-->
                <div class="specification_item_i">
                  <div
                    v-for="(iItem, iIndex) in item.items"
                    :key="iIndex"
                    class="specification_item_i_item"
                  >
                    <div class="img_">
                      <!--                    <el-upload-->
                      <!--                      action="#"-->
                      <!--                      list-type="picture-card"-->
                      <!--                      :auto-upload="false"-->
                      <!--                      :http-request="handleFileUpload"-->
                      <!--                      v-model="iItem.i"-->
                      <!--                    >-->
                      <!--                      <img :src="iItem.i" v-if="iItem.i" />-->
                      <!--                      <img src="@/assets/common/def_img.png" v-else/>-->
                      <!--                    </el-upload>-->
                      <img src="@/assets/common/def_img.png" />
                    </div>
                    <el-input
                      v-model="iItem.n"
                      placeholder="名称(必填)"
                      style="width: 100%"
                      size="small"
                      @change="assemblyAttributeData"
                      @input="forceUpdate($event)"
                      @blur="assemblyAttrBlur(iItem)"
                    />
                    <div class="delete_img_" @click="deleteSpecificationItem(index, iIndex)">
                      <img src="@/assets/common/delete.png" />
                    </div>
                  </div>
                  <div
                    class="add_specification_item_i_item"
                    @click="saveSpecificationItem(index)"
                    v-show="item.items && item.items.length !== 0"
                  >
                    +
                  </div>
                </div>
              </div>
              <!-- 添加单个规格-->
              <div
                :class="
                  isSddSpecification
                    ? 'add_specification_but'
                    : 'add_specification_but add_specification_but_no'
                "
                @click="addSpecification"
              >
                + 添加规格
              </div>
            </div>
          </el-form-item>
          <el-form-item label="商品规格" prop="specsPriceInfo">
            <div class="attribute_warp">
              <!-- 批量修改-->
              <div class="batch_warp">
                <el-select v-model="batch.batchType" placeholder="请选择" multiple collapse-tags>
                  <el-option
                    v-for="item in batch.option"
                    :key="item.n"
                    :label="item.n"
                    :value="item.n"
                  >
                  </el-option>
                </el-select>
                <el-input
                  v-model="batch.price"
                  style="width: 200px"
                  placeholder="价格"
                  class="mar_left"
                  type="text"
                >
                  <div slot="suffix" class="">元</div>
                </el-input>
                <el-input
                  v-model="batch.count"
                  style="width: 200px"
                  placeholder="数量"
                  class="mar_left"
                  type="text"
                >
                  <div slot="suffix" class="">件</div>
                </el-input>
                <el-button round @click="batchFill" class="mar_left">批量填写</el-button>
              </div>
              <el-table
                :data="form.specsPriceArr"
                style="width: 100%"
                max-height="450"
                :header-cell-style="{
                  color: '#000000',
                  background: '#dcdfe642'
                }"
                size="mini"
              >
                >
                <el-table-column prop="n" label="名称"> </el-table-column>
                <el-table-column prop="p" label="价格">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.p"
                      placeholder="请输入"
                      size="small"
                      type="text"
                      @input="forceUpdate($event)"
                    >
                      <div slot="suffix" class="">元</div>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="s" label="库存数量">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.s"
                      placeholder="请输入"
                      size="small"
                      type="text"
                      @input="forceUpdate($event)"
                    >
                      <div slot="suffix" class="">件</div>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="m" label="商家编号">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.m"
                      placeholder="请输入"
                      size="small"
                      @input="forceUpdate($event)"
                    />
                  </template>
                </el-table-column>
                <el-table-column prop="supplyPrice" label="供货价">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.supplyPrice"
                      placeholder="请输入"
                      size="small"
                      type="text"
                      @input="forceUpdate($event)"
                    >
                      <div slot="suffix" class="">元</div>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150px">
                  <template slot-scope="scope">
                    <div class="delete-specs-price" @click="onDeleteSpecs(scope.row, scope.$index)">
                      删除
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item label="原价" prop="adPrice">
            <el-input v-model="form.adPrice" placeholder="请输入" style="width: 60%" />
          </el-form-item>
          <el-form-item label="供货价格" prop="supplyPrice">
            <el-input v-model="form.supplyPrice" placeholder="请输入" style="width: 60%" />
          </el-form-item>
          <el-form-item label="是否推荐" prop="isRecomm">
            <el-radio-group v-model="form.isRecomm">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-card>

      <!--      商品主图，详情设置-->
      <el-card class="box-card card_but" shadow="hover">
        <div slot="header" class="clearfix">
          <span>图文描述</span>
        </div>
        <div class="text item">
          <el-form-item label="商品主图地址" prop="mainGraph">
            <UploadList
              :typeProps="UPLOAD_IMG_TYPE.BRAND"
              @valueFunc="getImgsValueFunc"
              paramsType="mainGraph"
              :model="form.mainGraph"
              :maxCount="1"
            />
          </el-form-item>

          <el-form-item label="商品图地址" prop="goodsGraph">
            <UploadList
              :typeProps="UPLOAD_IMG_TYPE.BRAND"
              @valueFunc="getImgsValueFunc"
              paramsType="goodsGraph"
              :model="form.goodsGraph"
              :maxCount="6"
            />
          </el-form-item>

          <el-form-item label="商品详情介绍" prop="detailInfo">
            <quill-editor
              v-model="form.detailInfo"
              class="content_warp"
              ref="myQuillEditor"
              :options="editorOption"
            ></quill-editor>
          </el-form-item>
        </div>
      </el-card>

      <!--      类目属性-->
      <el-card class="box-card card_but" shadow="hover">
        <div slot="header" class="clearfix">
          <span>类目属性</span>
        </div>
        <div class="text item">
          <el-row :gutter="40">
            <el-col :span="8">
              <el-form-item label="适用年龄" prop="porpAge">
                <el-input v-model="form.porpAge" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="适用性别" prop="porpSex">
                <el-input v-model="form.porpSex" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="风格" prop="porpStyle">
                <el-input v-model="form.porpStyle" placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="40">
            <el-col :span="8">
              <el-form-item label="货号" prop="porpNum">
                <el-input v-model="form.porpNum" placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上市时间" prop="porpOntime">
                <el-date-picker
                  v-model="form.porpOntime"
                  type="date"
                  placeholder="选择日期"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="产地" prop="porpOrigin">
                <el-input v-model="form.porpOrigin" placeholder="请输入" />
              </el-form-item>
            </el-col>

            <!-- 是否限时 -->
            <el-col :span="8">
              <el-form-item label="是否限时" prop="limitedTime">
                <el-radio-group v-model="form.limitedTime">
                  <el-radio :label="1" :key="1">是</el-radio>
                  <el-radio :label="0" :key="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-card>

      <!--      邮费模版-->
      <el-card class="box-card card_but" shadow="hover">
        <div slot="header" class="clearfix">
          <span>物流服务</span>
        </div>
        <div class="text item">
          <el-form-item label="邮费模版" prop="postagesId">
            <el-select
              v-model="form.postagesId"
              placeholder="选择邮费模版"
              style="width: 100%"
              class="filter-item"
              clearable
            >
              <el-option
                v-for="item in postagesOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </div>
      </el-card>
    </el-form>
    <div v-if="false" slot="footer" class="dialog-footer">
      <el-button @click="jumpList">取消</el-button>
      <el-button type="primary" @click="saveAddOrEditData" :loading="btnLoading">确定</el-button>
    </div>
    <el-upload
      action="#"
      list-type="picture-card"
      class="uploadFile"
      :multiple="true"
      :show-file-list="false"
      :http-request="handleFileUpload"
      :before-upload="beforeUpload"
      v-show="false"
    >
    </el-upload>
    <el-dialog
      :visible.sync="detailPreviewVisible"
      append-to-body
      title="商品详情图预览"
      width="720px"
      center
    >
      <div class="detail-preview-body">
        <el-button
          v-if="detailImages.length > 1"
          icon="el-icon-arrow-left"
          circle
          class="preview-nav-btn prev"
          :disabled="detailPreviewIndex <= 0"
          @click="prevDetailPreview"
        />
        <img :src="detailPreviewUrl" class="detail-preview-img" alt="详情图预览" />
        <el-button
          v-if="detailImages.length > 1"
          icon="el-icon-arrow-right"
          circle
          class="preview-nav-btn next"
          :disabled="detailPreviewIndex >= detailImages.length - 1"
          @click="nextDetailPreview"
        />
      </div>
      <div v-if="detailImages.length > 1" class="preview-counter">
        {{ detailPreviewIndex + 1 }} / {{ detailImages.length }}
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.add_edit_product_warp {
  background-color: #dcdfe642;
  padding: 20px 4%;
}

.card_but {
  margin-bottom: 20px;
  padding: 20px;
}

//规格
.specification_warp {
  background: #f7f8fa;
  padding: 10px;

  .but_left {
    margin-left: 10px;
  }

  .specification_item {
    margin-bottom: 10px;

    .specification_item_isEdit {
      display: flex;
    }

    .specification_item_i {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .specification_item_i_item {
        width: 25%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: 20px;

        .img_ {
          height: 26px;
          width: 28px;
          border: 1px dashed #d7dbe0;
          margin-right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 6px;
          cursor: pointer;

          img {
            width: 50%;
            height: 50%;
          }

          ::v-deep .el-upload--picture-card {
            height: 34px;
            width: 34px;
            line-height: 38px;
          }
        }

        .delete_img_ {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
          cursor: pointer;

          img {
            width: 20px;
            height: 20px;
          }
        }
      }

      .add_specification_item_i_item {
        border: 1px solid rgba(61, 94, 255, 0.15);
        border-radius: 10px;
        width: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
      }

      .add_specification_item_i_item:hover {
        color: #111;
        background: #ebecf0;
        border-color: #ebecf0;
      }
    }
  }

  .add_specification_but {
    border: 1px solid rgba(61, 94, 255, 0.15);
    border-radius: 10px;
    width: 60%;
    height: 41px;
    text-align: center;
    cursor: pointer;
  }

  .add_specification_but:hover {
    color: #111;
    background: #ebecf0;
    border-color: #ebecf0;
  }

  .add_specification_but_no {
    border: 1px solid rgba(61, 94, 255, 0.15);
    cursor: not-allowed;
  }
}

@media screen and (max-width: 1980px) {
  .attribute_warp {
    width: 100%;
  }
}

@media screen and (min-width: 1980px) {
  .attribute_warp {
    width: 60%;
  }
}

.attribute_warp {
  //width: 60%;
  .attribute_table_header_warp {
    background-color: red;
  }

  .batch_warp {
    display: flex;
    margin-bottom: 10px;
  }

  .mar_left {
    margin-left: 10px;
  }

  ::v-deep .el-input__suffix {
    top: 6px;
  }
}

.dialog-footer {
  text-align: center;
}

.content_warp {
  .uploadFile {
    width: 0;
    height: 0;
    display: none;
  }

  ::v-deep {
    .ql-container {
      min-height: 400px;
    }

    .ql-editor {
      min-height: 400px;

      img {
        display: block;
        width: auto;
        max-width: 320px;
        max-height: 240px;
        margin: 10px 0;
        object-fit: contain;
      }
    }
  }
}

.detail-image-manager {
  margin-top: 16px;
  padding: 16px;
  background: #f7f8fa;
  border: 1px dashed #c0c4cc;
  border-radius: 6px;
  transition: border-color 180ms ease, background-color 180ms ease;
}

.detail-image-manager.is-dragover {
  background: #ecf5ff;
  border-color: #409eff;
}

.detail-image-manager__heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 14px;

  strong {
    color: #303133;
    font-size: 14px;
  }

  span {
    margin-left: 10px;
    color: #606266;
    font-size: 12px;
  }
}

.detail-image-input {
  display: none;
}

.detail-image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.detail-image-item {
  position: relative;
  width: 112px;
  height: 88px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  user-select: none;
  -webkit-user-drag: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    user-select: none;
    -webkit-user-drag: none;
  }

  .detail-image-actions {
    position: absolute;
    top: 6px;
    right: 6px;
    display: flex;
    gap: 4px;
    z-index: 2;

    i {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      color: #fff;
      background: rgba(31, 35, 41, 0.72);
      border-radius: 4px;
      font-size: 13px;

      &:hover {
        background: rgba(31, 35, 41, 0.92);
      }
    }

    .el-icon-rank {
      cursor: grab;
    }

    .el-icon-zoom-in {
      cursor: pointer;
    }
  }
}

.detail-preview-body {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  max-height: 70vh;
  overflow: hidden;
}

.detail-preview-img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  display: block;
  border-radius: 4px;
}

.preview-nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background: rgba(0, 0, 0, 0.5) !important;
  color: #fff !important;
  border: none !important;
  font-size: 18px !important;

  &:hover {
    background: rgba(0, 0, 0, 0.75) !important;
  }

  &.prev {
    left: 10px;
  }

  &.next {
    right: 10px;
  }
}

.preview-counter {
  text-align: center;
  margin-top: 10px;
  color: #909399;
  font-size: 14px;
}

.detail-image-item.is-dragging {
  opacity: 0.45;
}

.detail-image-list ::v-deep .detail-sortable-chosen,
.detail-image-list ::v-deep .detail-sortable-drag {
  cursor: grabbing;
}

.detail-image-list ::v-deep .detail-sortable-ghost {
  opacity: 0.35;
}

.detail-image-index {
  position: absolute;
  bottom: 6px;
  left: 6px;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  color: #fff;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
  background: rgba(31, 35, 41, 0.72);
  border-radius: 4px;
  z-index: 1;
  pointer-events: none;
}

.detail-image-empty {
  min-height: 72px;
  color: #606266;
  font-size: 13px;
  line-height: 72px;
  text-align: center;
}

.subsidy-sort-hint {
  display: inline-block;
  margin-top: 6px;
}

@media (prefers-reduced-motion: reduce) {
  .detail-image-manager {
    transition: none;
  }
}

.delete-specs-price {
  border: 1px solid #7934f6;
  border-radius: 5px;
  width: 100px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28rpx;
  color: #7934f6;
  margin-left: 20rpx;
  cursor: pointer;
}

.product-editor-shell {
  max-width: 1680px;
  min-height: calc(100vh - 130px);
  margin: 0 auto;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.editor-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 76px;
  padding: 0 24px;
  border-bottom: 1px solid #ebeef5;

  h2 {
    margin: 0 0 6px;
    color: #1f2329;
    font-size: 20px;
    line-height: 1.25;
  }

  p {
    margin: 0;
    color: #606266;
    font-size: 13px;
  }
}

.heading-actions {
  display: flex;
  gap: 10px;
}

.product-editor-form {
  padding: 0 24px 28px;
}

.editor-tabs {
  ::v-deep .el-tabs__header {
    margin-bottom: 0;
  }

  ::v-deep .el-tabs__item {
    height: 52px;
    line-height: 52px;
  }

  ::v-deep .el-tabs__content {
    overflow: visible;
  }
}

.form-section {
  padding: 26px 4px 8px;
  border-bottom: 1px solid #ebeef5;

  &:last-child {
    border-bottom: 0;
  }

  h3 {
    margin: 0 0 22px;
    color: #1f2329;
    font-size: 16px;
    line-height: 1.4;
  }
}

.form-grid {
  display: grid;
  column-gap: 24px;
}

.form-grid-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.form-grid-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.compact-grid {
  max-width: 760px;
}

.product-editor-form ::v-deep .el-select,
.product-editor-form ::v-deep .el-cascader {
  width: 100%;
}

.field-hint {
  margin-left: 10px;
  color: #606266;
  font-size: 12px;
}

.supplier-source-note {
  min-height: 40px;
  padding: 0 14px;
  color: #606266;
  line-height: 40px;
  background: #f5f7fa;
  border-radius: 4px;
}

.section-heading-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;

  h3 {
    margin-bottom: 4px;
  }

  p {
    margin: 0;
    color: #606266;
    font-size: 13px;
  }
}

.spec-builder {
  padding: 18px;
  background: #f7f8fa;
  border-radius: 6px;
}

.spec-group-row {
  position: relative;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr) 36px;
  gap: 22px;
  padding: 18px 0;
  border-bottom: 1px solid #e4e7ed;

  &:first-child {
    padding-top: 0;
  }

  &:last-of-type {
    margin-bottom: 18px;
  }
}

.spec-group-name,
.spec-values {
  > span {
    display: block;
    margin-bottom: 8px;
    color: #606266;
    font-size: 13px;
  }
}

.spec-value-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.spec-value-input {
  display: flex;
  width: 220px;

  ::v-deep .el-input {
    flex: 1;
  }

  .el-button {
    flex: 0 0 28px;
    margin-left: 4px;
  }
}

.remove-group-button {
  align-self: end;
  margin-bottom: 7px;
  color: #f56c6c;
}

.sku-section {
  padding-bottom: 28px;
}

.batch-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;

  .el-input {
    width: 140px;
  }
}

.sku-table {
  width: 100%;

  ::v-deep .el-input__inner {
    padding-left: 8px;
    padding-right: 28px;
  }
}

.sku-image-upload {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  overflow: hidden;
  color: #7934f6;
  background: #f7f4ff;
  border: 1px dashed #b9a0ef;
  border-radius: 4px;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.detail-section {
  padding-bottom: 30px;
}

@media screen and (max-width: 1200px) {
  .form-grid-3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 760px) {
  .add_edit_product_warp {
    padding: 10px;
  }

  .editor-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 14px;
    padding: 18px;
  }

  .product-editor-form {
    padding-right: 14px;
    padding-left: 14px;
  }

  .form-grid-2,
  .form-grid-3 {
    grid-template-columns: minmax(0, 1fr);
  }

  .spec-group-row {
    grid-template-columns: minmax(0, 1fr) 36px;
  }

  .spec-values {
    grid-column: 1 / -1;
  }
}
</style>

<style>
.detail-sort-drag-ghost {
  position: fixed;
  top: -1000px;
  left: -1000px;
  z-index: -1;
  width: 120px;
  height: 40px;
  color: #fff;
  font-size: 13px;
  line-height: 40px;
  text-align: center;
  background: rgba(31, 35, 41, 0.88);
  border-radius: 4px;
  pointer-events: none;
}
</style>
